import { ROOT_CAUSE_SOURCE } from 'frontend/constants/problems'

export const IDENTIFIED = 0
export const PLANIFIED = 1
export const ONGOING = 2
export const DONE = 3
export const VERIFIED = 4
export const EXPIRED = 100

export const SECURITY = 0
export const MACHINE = 1
export const QUALITY = 2
export const DELIVERY = 3
export const COST = 4
export const PEOPLE = 5

export const ACTION_STATUS_CLASS = {
  0: 'status-identified',
  1: 'status-planified',
  2: 'status-on_going',
  3: 'status-finalised',
  4: 'status-verified',
  100: 'status-expired',
}

export const ACTION_PLAN_TYPE = Object.freeze({
  empty: 0, corrective: 1, preventive: 2, containment: 3,
})

export const ACTION_TYPES_INFO = {
  [ACTION_PLAN_TYPE.empty]: {
    'single_label': 'sources.messages.immediate',
    'label': '',
    'source': 'problemsolving',
    'name': 'problemsolving',
  },
  [ACTION_PLAN_TYPE.corrective]: {
    'single_label': 'actions.messages.corrective_label',
    'label': 'actions.messages.corrective_actions',
    'source': 'corrective-actions',
    'name': 'corrective-actions',
  },
  [ACTION_PLAN_TYPE.preventive]: {
    'single_label': 'actions.messages.preventive_label',
    'label': 'actions.messages.preventive_actions',
    'source': 'preventive-actions',
    'name': 'preventive-actions',
  },
  [ACTION_PLAN_TYPE.containment]: {
    'single_label': 'actions.messages.containment_label',
    'label': 'actions.messages.containment_actions',
    'source': 'containment-actions',
    'name': 'containment-actions',
  },
}

export const IMMEDIATE_ACTION_TYPES = Object.freeze({
  immediate_action: 0, at_customer: 1, at_production_place: 2, at_stock: 3,
})

export const IMMEDIATE_ACTION_TYPES_INFO = {
  [IMMEDIATE_ACTION_TYPES.immediate_action]: {
    'label': 'actions.messages.immediate_action_title',
    'source': 'problemsolving',
    'name': 'immediate-actions',
  },
  [IMMEDIATE_ACTION_TYPES.at_customer]: {
    'label': 'actions.messages.action_at_customer',
    'source': 'problemsolving',
    'name': 'at-customer',
  },
  [IMMEDIATE_ACTION_TYPES.at_production_place]: {
    'label': 'actions.messages.action_at_production_place',
    'source': 'problemsolving',
    'name': 'at-production-place',
  },
  [IMMEDIATE_ACTION_TYPES.at_stock]: {
    'label': 'actions.messages.action_at_stock',
    'source': 'problemsolving',
    'name': 'at-stock',
  },
}

export const ROOT_CAUSE_ACTIONS_INFO = {
  [ROOT_CAUSE_SOURCE.detection]: {
    'label': 'problem_solving.messages.root_cause_source_detection',
    'source': 'problemsolving',
    'name': 'immediate-actions',
  },
  [ROOT_CAUSE_SOURCE.occurence]: {
    'label': 'problem_solving.messages.root_cause_source_occurrence',
    'source': 'problemsolving',
    'name': 'at-customer',
  },
}

export const ACTIONS_STATUS_ICONS = {
  [IDENTIFIED]: {
    id: IDENTIFIED,
    icon: 'circle-magnifying-glass',
    iconName: 'ActionCustom',
    color: '#315fbc',
    text: 'actions.messages.identified',
  },
  [PLANIFIED]: {
    id: PLANIFIED,
    icon: 'circle-calendar',
    iconName: 'ActionPlannedCustom',
    color: '#4f4f4f',
    text: 'actions.messages.planified',
  },
  [ONGOING]: {
    id: ONGOING,
    icon: 'circle-hammer',
    iconName: 'ActionOnGoingCustom',
    color: '#cc9937',
    text: 'actions.messages.on_going',
  },
  [DONE]: {
    id: DONE,
    icon: 'circle-star',
    iconName: 'ActionClosedCustom',
    color: '#61a573',
    text: 'actions.messages.finalised',
  },
  [VERIFIED]: {
    id: VERIFIED,
    icon: 'circle-tick',
    iconName: 'ActionVerifiedCustom',
    color: '#2dce57',
    text: 'actions.messages.verified',
  },
}

export const ACTION_THROTTLING_DURATION = 650

export const LEANCENTER_SOURCE = 'actions'

export const UNKNOWN_SOURCE = '*'

export const STATUS_FIELD = 0
export const PERSON_FIELD = 1
export const WHEN_FIELD = 2

export const DELAY_TIMEOUT_MS = 100
